/** Must match `public.is_question_set_status_transition_allowed`. */
export enum QuestionSetStatus {
  Draft = 'draft',
  Published = 'published',
  Archived = 'archived',
}

/**
 * Who a set is for. A public set is sat by many classes, so while it is active
 * no other active set may hold its questions.
 */
export enum QuestionSetVisibility {
  Private = 'private',
  Public = 'public',
}

/** How candidates are drawn. The blueprint stores it even though there is only one value. */
export enum QuestionSetDistribution {
  Random = 'random',
}

/** What a blueprint does with a question already used in a published set. */
export enum QuestionSetPreviouslyUsed {
  Include = 'include',
}
